/* eslint-disable react/forbid-prop-types */
import { Grid2 } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

function PayablesTour({ driverObj, tourCompletion, setDialogOpen, setTourOn }) {
  const navigate = useNavigate();

  const handleClose = () => setDialogOpen(false);

  const startTour = () => {
    navigate('/constructions/tour/payables');
    setTimeout(() => {
      driverObj.drive(tourCompletion.payables.step);
      setTourOn(true);
      handleClose();
    }, 300);
  };

  return (
    <Dialog
      sx={{ width: '80%', margin: 'auto' }}
      open
      onClose={handleClose}
      PaperProps={{ style: { maxWidth: 'none' } }}
    >
      <Box style={{ padding: '30px' }}>
        <DialogTitle style={{ marginBottom: '15px' }}>
          <Grid2 container direction="column" alignItems="center">
            <Grid2 item style={{ marginBottom: '8px' }}>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '600',
                  fontSize: '1.2rem',
                }}
              >
                Bem vindo(a) à
              </Typography>
            </Grid2>
            <Grid2 item>
              <Typography
                component="h3"
                style={{
                  fontFamily: 'Montserrat',
                  fontWeight: '800',
                  fontSize: '2.5rem',
                }}
              >
                Lançamentos
              </Typography>
            </Grid2>
          </Grid2>
        </DialogTitle>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Esta é a sua tela de lançamentos, onde você pode gerenciar seus
          lançamentos de forma simples e prática.
        </Typography>
        <Typography
          component="p"
          style={{ fontFamily: 'Montserrat', fontSize: '1rem' }}
        >
          Nesta página, é possível adicionar, editar ou remover lançamentos,
          facilitando o controle completo das suas operações.
        </Typography>
        <Grid2 container justifyContent="center">
          <Grid2 item style={{ margin: '25px 0 15px 0' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ fontSize: '1.2rem', width: '12em' }}
              onClick={startTour}
            >
              Vamos Lá!
            </Button>
          </Grid2>
        </Grid2>
      </Box>
    </Dialog>
  );
}

PayablesTour.propTypes = {
  driverObj: PropTypes.object.isRequired,
  tourCompletion: PropTypes.object.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
};

export default PayablesTour;
